// import packages
import React, {useState} from "react";
import {connect} from "react-redux";
import {Checkbox, Modal} from 'antd';
import {isEmail} from "validator";

// Import assets
import "./reserve-modal.scss"

// Import Components
import {InputGroup} from "../ui-elements/input-group/inputGroup";

// Import utils
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ReserveHouse} from "../../redux/actions";
import { AREA_TYPES, RESERVE_MODAL_TITLE_TYPES } from "../../constants/constants";
import {CloseModalIcon, ReserveModalCloseIcon} from "../../assets/images";
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";


function ReserveModal(props) {
    const {house, staticTexts} = props
    const [checked, setChecked] = useState(false)
    const [fieldsData, setFieldsData] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
    })
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        phoneNumber: "",
        checked:false,
    })
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [confirmBtnDisable, setConfirmBtnDisable] = useState(false);
    const [modalTitleType, setModalTitleType] = useState("");
    const confirmReserve = () => {

        if (validate()) {
            setConfirmLoading(true);
            const reqData = {
                ...fieldsData
            }
                reqData.area = house?.id
            props.ReserveHouse(reqData).then(() => {
                setTimeout(() => {
                    setConfirmLoading(false);
                    setModalTitleType(RESERVE_MODAL_TITLE_TYPES.success);
                    setConfirmBtnDisable(true)
                }, 2000)
                setTimeout(() => {
                    closeModal()
                    setModalTitleType(RESERVE_MODAL_TITLE_TYPES.title);
                    setConfirmBtnDisable(false)
                }, 7000)
            }).catch((err) => {
                if(err.response?.data?.slug === "email") {
                    setConfirmLoading(false);
                    setErrors({
                        ...errors,
                        email: true
                    })
                } else {
                    setTimeout(() => {
                        setConfirmLoading(false);
                        setConfirmBtnDisable(true)
                        setModalTitleType(RESERVE_MODAL_TITLE_TYPES.error);
                    }, 2000)
                    setTimeout(() => {
                        closeModal()
                        setModalTitleType(RESERVE_MODAL_TITLE_TYPES.title);
                        setConfirmBtnDisable(false)
                    }, 7000)
                }
            })
        }
    };
    const cancelReserve = () => {
        closeModal()
    };
    const closeModal = () => {
        props.toggleVisibility()
        setFieldsData({
            fullName: "",
            email: "",
            phoneNumber: "",
        })
        setErrors({})
    };

    function getInputValues(e) {
        const {name, value} = e.target
        if (name === "phoneNumber" && value && !/^[+\d]\d*$/.test(value)) {
            return
        }
        setFieldsData({
            ...fieldsData,
            [name]: value
        })

        setErrors({
            ...errors,
            [name]: false,
        })
    }

    function validate() {
        const errors = {};
        let result = true;
        Object.keys(fieldsData).forEach(key => {
            if (!fieldsData[key] || (key === 'email' && !isEmail(fieldsData?.email) || (key === 'phoneNumber' && fieldsData[key]?.length < 8))
            ) {
                errors[key] = true;
                result = false;
            }
        })
        if(!checked){
            errors.checked=true;
            result=false
        }
        setErrors(errors);
        return result;
    }
    return <Modal
        title={house?.type === 'APARTMENT' ? staticTexts?.modal_title_house : staticTexts?.modal_title_parking}
        className={`reservation-modal ${modalTitleType === RESERVE_MODAL_TITLE_TYPES.success ? "success" :
            (modalTitleType === RESERVE_MODAL_TITLE_TYPES.error ? "error" : "")} ${confirmBtnDisable ? "confirm-btn-disable" : ""}`}
        centered
        cancelText={confirmBtnDisable ? staticTexts?.modal_btn_close : staticTexts?.modal_btn_cancel}
        okText={staticTexts?.modal_btn_save}
        closeIcon={<ReserveModalCloseIcon/>}
        visible={props.visible}
        onOk={!confirmBtnDisable && confirmReserve}
        confirmLoading={confirmLoading}
        onCancel={cancelReserve}>
        <InputGroup
            inputType={'input'}
            type={"text"}
            value={fieldsData.fullName || undefined}
            error={errors.fullName}
            name={'fullName'}
            maxLength={100}
            placeholder={staticTexts?.modal_name_label}
            onChange={getInputValues}
        />
        <InputGroup
            inputType={'input'}
            type={"text"}
            value={fieldsData.email}
            error={errors.email}
            name={'email'}
            maxLength={50}
            placeholder={staticTexts?.modal_email_label}
            onChange={getInputValues}
        />
        <InputGroup
            inputType={'input'}
            type={"text"}
            value={fieldsData.phoneNumber}
            error={errors.phoneNumber}
            name={'phoneNumber'}
            maxLength={12}
            placeholder={staticTexts?.modal_phone_label}
            onChange={getInputValues}
        />
        <InputGroup
            inputType={'input'}
            type={"text"}
            disabled
            value={`${staticTexts?.[AREA_TYPES[house?.type]?.filter_page_title]} ${house?.areaNumber}`}
            placeholder={staticTexts?.modal_house_number_label}
        />
        <div className={'checkbox-block'}>
            <Checkbox className={`checkbox-wrapper ${errors.checked ? "error" : ''}`}
                      checked={checked}
                      onChange={() => {
                          errors.checked && setErrors({
                              ...errors,
                              checked: false,
                          })
                          setChecked(!checked)
                      }}>
                {staticTexts?.checkbox_text1} <Link to={getUrlWithLocal(`/privacy-policy`)} className={'checkbox-text'}>{staticTexts?.checkbox_text2}</Link>
            </Checkbox>
        </div>

    </Modal>

}

const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
]);

const mapDispatchToProps = {
    ReserveHouse
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveModal);
